
export class CustomerModel {
  name: string;
  address: string;
  phone: string;
  cpf: string;
  email: string;
  birthday: string;
  shoppingName: string;
  gender: number;
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/models/customer.model.ts